import AccountEdit from './AccountEdit'

export default AccountEdit;